/**
 * Prometheus metrics data source (phase 2).
 *
 * The Grafana dashboards in this repo query these metrics:
 *   - mcp_customer_blocked{account_id, server_id}
 *   - mcp_request_total{account_id, server_id}
 *   - mcp_error_total{account_id, server_id}
 *   - mcp_request_duration_seconds_{sum,count}{account_id}
 *   - mcp_token_context_usage_ratio{account_id, server_id}
 *
 * For now this returns empty maps, so all metric fields on MatrixCell are
 * null (the UI renders "—"). When ready, implement `fetchInstant` against the
 * Prometheus HTTP API and populate the maps keyed by `${account_id}|${server_id}`.
 */

/** Metrics for one account×server pair. All fields nullable. */
export interface CellMetrics {
  error_rate_pct: number | null
  requests_per_min: number | null
  avg_latency_ms: number | null
}

const EMPTY: CellMetrics = {
  error_rate_pct: null,
  requests_per_min: null,
  avg_latency_ms: null,
}

/**
 * Returns a map keyed by `${account_id}|${server_id}` → CellMetrics.
 * Phase 1: always empty. Phase 2: fill from PromQL instant queries.
 */
export async function getMetricsMap(): Promise<Map<string, CellMetrics>> {
  return new Map<string, CellMetrics>()
}

export function metricsFor(
  map: Map<string, CellMetrics>,
  accountId: string,
  serverId: string
): CellMetrics {
  return map.get(`${accountId}|${serverId}`) ?? EMPTY
}
